jQuery('#cctvOnRightContent').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    fade: true,
    appendDots: jQuery('#cctvOnRightContentDots'),
});

jQuery('.staggered-content-cctv-on-right .hotspot').click(function() {
    switch (jQuery('.staggered-content-cctv-on-right .image-container').attr('data-status')) {
        case 'open':
            jQuery('.staggered-content-cctv-on-right .image-container').attr('data-status', 'closed');
            
            jQuery('.staggered-content-cctv-on-right .video-closing').show();
            document.getElementById('cctvClosing').play();

            jQuery('.staggered-content-cctv-on-right .video-opening').hide();
            jQuery('.staggered-content-cctv-on-right .img-open').hide();
            break;
        case 'closed':
            jQuery('.staggered-content-cctv-on-right .image-container').attr('data-status', 'open');
            
            jQuery('.staggered-content-cctv-on-right .video-opening').show();
            document.getElementById('cctvOpening').play();

            jQuery('.staggered-content-cctv-on-right .video-closing').hide();
            jQuery('.staggered-content-cctv-on-right .img-closed').hide();
            break;
    }
});